import dayjs from 'dayjs';
import CellAbstract from './CellAbstract';
import React from 'react';
import { CELL_DATE_PROPS } from './Types';

class CellDate extends CellAbstract<CELL_DATE_PROPS, {}> {
  private formatDate = (value, format) => {
    const date = dayjs(value);
    return date.format(format);
  };

  render() {
    const {
      cellConfig = {},
      dataIndex,
      dataItem,
      field,
      notAssigned = ''
    } = this.props;
    const value = dataItem[(field || dataIndex)];
    const date = value ? this.formatDate(value, cellConfig.format) : notAssigned;
    const content = (
      <span
        className={'tp-text-ellipsis'}
      >
        {date}
      </span>
    );

    return this.renderCell(content);
  }
}

export default CellDate;
